import { render, staticRenderFns } from "./referrer-details-loader.vue?vue&type=template&id=7d4fa94b"
import script from "./referrer-details-loader.vue?vue&type=script&lang=js"
export * from "./referrer-details-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports